module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/COB大连线.7a73b982.jpg";